import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import Loadable from "../layouts/full/shared/loadable/Loadable";
import { RouterName } from "./RouterName";
import { dataLocalStorage, getLocalStorage } from "src/helper/publicFunction";

/* ***Layouts**** */
const FullLayout = Loadable(lazy(() => import("../layouts/full/FullLayout")));
const BlankLayout = Loadable(
  lazy(() => import("../layouts/blank/BlankLayout"))
);

/* ****Pages***** */
const Banners = Loadable(lazy(() => import("src/pages/banners/view")));
const Bars = Loadable(lazy(() => import("src/pages/bars/view")));
const BarImages = Loadable(lazy(() => import("src/pages/bar_images/view")));
const Events = Loadable(lazy(() => import("src/pages/events/view")));
const EventImg = Loadable(lazy(() => import("src/pages/eventImages/view")));
const Founders = Loadable(lazy(() => import("src/pages/founders/view")));
const Menu = Loadable(lazy(() => import("src/pages/menu/view")));
const MenuCocktails = Loadable(lazy(() => import("src/pages/menu_cocktails/view")));
const Services = Loadable(lazy(() => import("src/pages/services/view")));
const ServiceImages = Loadable(lazy(() => import("src/pages/service_images/view")));

const Stations = Loadable(lazy(() => import("src/pages/stations/view")));
const StationImages = Loadable(lazy(() => import("src/pages/station_images/view")));
const Seo = Loadable(lazy(() => import("src/pages/seo/view")));

const Clients = Loadable(lazy(() => import("src/pages/clients/view")));

const Quotation = Loadable(lazy(() => import("src/pages/quotation/view"))
);
const Settings = Loadable(lazy(() => import("src/pages/settings/view")));
const LegalInformation = Loadable(
  lazy(() => import("src/pages/settings/legal_information"))
);
const EventImages = Loadable(
  lazy(() => import("src/pages/settings/eventsImages"))
);


const Logs = Loadable(lazy(() => import("src/pages/admins_logs/view")));
const Contact = Loadable(
  lazy(() => import("src/pages/settings/contact"))
);


// authentication
const Login = Loadable(
  lazy(() => import("../views/authentication/auth/Login"))
);

const ForgotPassword = Loadable(
  lazy(() => import("../views/authentication/auth/ForgotPassword"))
);
const ResetPassword = Loadable(
  lazy(() => import("src/views/authentication/auth/ResetPassword"))
);

const Error = Loadable(lazy(() => import("../views/authentication/Error")));
const Maintenance = Loadable(
  lazy(() => import("../views/authentication/Maintenance"))
);

const AdminsPage = Loadable(lazy(() => import("../pages/admins/admins/view")));
const PrivilegesPage = Loadable(
  lazy(() => import("../pages/admins/privileges/view"))
);

let data = getLocalStorage(dataLocalStorage.privileges);

const Router = [
  {
    path: "/",
    element: <FullLayout />,
    children: [
      {
        path: "/",
        exact: true,
        element: (
          <Navigate
            to={
              data["1"]?.access_read == 1
                ? RouterName.admins.admins
                : data["5"]?.access_read == 1
                  ? RouterName.settings.settings
                  : data["9"]?.access_read == 1
                    ? RouterName.events.events
                    : data["9"]?.access_read == 1
                      ? RouterName.event_img.event_img
                      : data["11"]?.access_read == 1
                        ? RouterName.bars.bars
                        : data["11"]?.access_read == 1
                          ? RouterName.bar_images.bar_images
                          : data["8"]?.access_read == 1
                            ? RouterName.clients.clients
                            : data["5"]?.access_read == 1
                              ? RouterName.contact.contact
                              : data["16"]?.access_read == 1
                                ? RouterName.menu.menu
                                : data["16"]?.access_read == 1
                                  ? RouterName.menu_cocktails.menu_cocktails
                                  : data["6"]?.access_read == 1
                                    ? RouterName.services.services
                                    : data["6"]?.access_read == 1
                                      ? RouterName.service_images.service_images
                                      : data["3"]?.access_read == 1
                                        ? RouterName.stations.stations
                                        : data["3"]?.access_read == 1
                                          ? RouterName.station_images.station_images
                                          : data["14"]?.access_read == 1
                                            ? RouterName.seo.seo
                                            : data["7"]?.access_read == 1
                                              ? RouterName.founders.founders
                                              : data["10"]?.access_read == 1
                                                ? RouterName.banners.banners
                                                : data["12"]?.access_read == 1
                                                  ? RouterName.admins_logs.admins_logs
                                                  : data["12"]?.access_read == 1
                                                    ? RouterName.quotation.quotation
                                                    : data["15"]?.access_read == 1
            }
          />
        ),
      },

      {
        path: RouterName.admins.admins,
        exact: true,
        element: <AdminsPage />,
      },
      data["1"]?.access_read == 1 && {
        path: RouterName.admins.privileges,
        exact: true,
        element: <PrivilegesPage />,
      },
      data["5"]?.access_read == 1 && {
        path: RouterName.settings.settings,
        exact: true,
        element: <Settings />,
      },
      data["5"]?.access_read == 1 && {
        path: RouterName.legal_information.legal_information,
        exact: true,
        element: <LegalInformation />,
      },

      data["10"]?.access_read == 1 && {
        path: RouterName.banners.banners,
        exact: true,
        element: <Banners />,
      },
      data["11"]?.access_read == 1 && {
        path: RouterName.bars.bars,
        exact: true,
        element: <Bars />,
      },
      data["11"]?.access_read == 1 && {
        path: RouterName.bar_images.bar_images,
        exact: true,
        element: <BarImages />,
      },
      data["8"]?.access_read == 1 && {
        path: RouterName.clients.clients,
        exact: true,
        element: <Clients />,
      },
      data["9"]?.access_read == 1 && {
        path: RouterName.events.events,
        exact: true,
        element: <Events />,
      },
      data["9"]?.access_read == 1 && {
        path: RouterName.event_img.event_img,
        exact: true,
        element: <EventImg />,
      },

      data["16"]?.access_read == 1 && {
        path: RouterName.menu.menu,
        exact: true,
        element: <Menu />,
      },
      data["16"]?.access_read == 1 && {
        path: RouterName.menu_cocktails.menu_cocktails,
        exact: true,
        element: <MenuCocktails />,
      },
      data["6"]?.access_read == 1 && {
        path: RouterName.services.services,
        exact: true,
        element: <Services />,
      },
      data["6"]?.access_read == 1 && {
        path: RouterName.service_images.service_images,
        exact: true,
        element: <ServiceImages />,
      },
      data["3"]?.access_read == 1 && {
        path: RouterName.stations.stations,
        exact: true,
        element: <Stations />,
      },
      data["11"]?.access_read == 1 && {
        path: RouterName.quotation.quotation,
        exact: true,
        element: <Quotation />,
      },
      data["3"]?.access_read == 1 && {
        path: RouterName.station_images.station_images,
        exact: true,
        element: <StationImages />,
      },
      data["14"]?.access_read == 1 && {
        path: RouterName.seo.seo,
        exact: true,
        element: <Seo />,
      },
      data["7"]?.access_read == 1 && {
        path: RouterName.founders.founders,
        exact: true,
        element: <Founders />,
      },
      data["5"]?.access_read == 1 && {
        path: RouterName.event_images.event_images,
        exact: true,
        element: <EventImages />,
      },

      {
        path: RouterName.contact.contact,
        exact: true,
        element: <Contact />,
      },

      data["12"]?.access_read == 1 && {
        path: RouterName.admins_logs.admins_logs,
        exact: true,
        element: <Logs />,
      },

    ],
  },
  {
    path: "/",
    element: <BlankLayout />,
    children: [
      { path: "/auth/404", element: <Error /> },
      { path: RouterName.auth.login, element: <Login /> },
      { path: RouterName.auth.forgotPassword, element: <ForgotPassword /> },
      { path: RouterName.auth.resetPassword, element: <ResetPassword /> },
      { path: RouterName.auth.maintenance, element: <Maintenance /> },
      { path: "*", element: <Navigate to="/auth/404" /> },
    ],
  },
];

export default Router;
